import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Try window scroll first
    window.scrollTo({ top: 0, behavior: "instant" });

    // Fallback for scrolling containers
    const mainContainer = document.querySelector("main") || document.body;
    if (mainContainer) mainContainer.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
